import { get, set, first, uniqBy } from 'global/lib/lodash';
import { useSelector, useDispatch, useStore } from 'react-redux';
import { SET_VIEW } from 'redux/actions/types';
import { setViewStyle } from 'redux/actions/view';
import { useScreen } from '../styles';
import Confirm from '../components/confirm';
import { useState } from 'react';

export const useView = (props) => {
  const view = useSelector((state) => state.view);
  const store = useStore();
  const dispatch = useDispatch();
  const { isMobileXS } = useScreen();

  const confirmState = useState({});

  const theme = get(view, 'style.palette.mode', 'light');

  const toggleTheme = () => {
    const key = 'style.palette.mode';
    const theme = get(view, key, 'light');
    const themes = ['light', 'dark'];

    const _view = { ...view };

    const newTheme = first(themes.filter((t) => t !== theme));
    set(_view, key, newTheme);

    dispatch({ type: SET_VIEW, view: _view });
    dispatch(setViewStyle());
  };

  const setView = (key, value) => {
    const _view = { ...store.getState().view };
    set(_view, key, value);
    dispatch({ type: SET_VIEW, view: _view });
  };

  const addNewTask = task => {
    if (!task) { return }

    const _view = store.getState().view;
    const newTasks = get(_view, 'task.new', []);

    setView('task.new', [ ...newTasks, task ]);
    setView('task.ignored', []);
  }

  const addNewTasks = tasks => {
    if (!tasks) { return }

    const _view = store.getState().view;
    const newTasks = get(_view, 'task.new', []);

    setView('task.new', uniqBy([ ...newTasks, ...tasks ], 'id'));
    setView('task.ignored', []);
  }

  const setTaskList = tasks => {
    if (!tasks) { return }

    const _view = store.getState().view;
    const newTasks = get(_view, 'task.list', []);

    setView('task.list', uniqBy([ ...newTasks, ...tasks ], 'id'));
  }

  const removeNewTask = task => {
    const _view = store.getState().view;
    const newTasks = get(_view, 'task.new', []);
    setView('task.new', newTasks.filter(t => t.id !== get(task, 'id')));
  }

  const removeNewTasks = () => {
    setView('task.new', []);
  }

  const renderConfirm = () => {
    return <Confirm {...confirmState[0]} />
  }

  return {
    view,
    getView: () => store.getState().view,
    setView,
    theme,
    addNewTask,
    addNewTasks,
    removeNewTask,
    removeNewTasks,
    setTaskList,
    isDark: theme === 'dark',
    toggleTheme,
    isMobile: isMobileXS,
    confirmState,
    renderConfirm,
    store,
  };
};
